import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective } from '@nk/ui-lib';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { DateColumnComponent } from './components/date-column/date-column.component';
import { LinkColumnComponent } from './components/link-column/link-column.component';
import { TextTagListColumnComponent } from './components/text-list-column/text-tag-list-column.component';
import { DatatableComponent } from './datatable.component';
import { DatatableRowDetailsDirective } from './directives/datatable-row-details.directive';
import { DatatableRowDirective } from './directives/datatable-row.directive';

const EXPORT_COMPONENTS = [DatatableComponent, DateColumnComponent, TextTagListColumnComponent];

@NgModule({
  declarations: [DatatableRowDirective, DatatableRowDetailsDirective, ...EXPORT_COMPONENTS],
  imports: [CommonModule, NgxDatatableModule, TranslateModule, RouterModule, ButtonDirective, LinkColumnComponent],
  exports: [...EXPORT_COMPONENTS],
})
export class DatatableModule {}
